// src/components/pages/ReturnPolicy.js
import React, { useEffect } from 'react';
import { Container, Box, Typography, Divider, useTheme } from '@mui/material';
import SeoHead from '../seo/SeoHead';

export default function ReturnPolicy() {
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <>
      {/* SEO meta tags */}
      <SeoHead
        title="Return Policy – Marrakech Reserve"
        description="Marrakech Reserve's return policy: We do not accept returns or exchanges."
        url="https://marrakech-reserve.com/return-policy"
        keywords="Marrakech Reserve, return policy, no returns, no exchanges"
      />

      <Container
        component="section"
        sx={{
          py: { xs: 4, md: 8 },
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: '"Playfair Display", serif',
            mb: 3,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            textAlign: 'center',
          }}
        >
          Return Policy
        </Typography>

        <Divider sx={{ mb: 4, borderColor: theme.palette.text.primary, opacity: 0.3 }} />

        <Box
          sx={{
            maxWidth: '700px',
            mx: 'auto',
            textAlign: 'center',
            p: { xs: 2, md: 3 },
            backgroundColor: theme.palette.grey[100],
            borderRadius: 2,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Georgia, serif',
              lineHeight: 1.7,
              fontSize: '1.1rem',
              color: theme.palette.text.primary,
            }}
          >
            At Marrakech Reserve, every bottle is crafted with the highest quality standards.  
            Due to the nature of our premium olive oil products, <strong>we do not accept returns or exchanges</strong>.  
            Please review your order carefully before completing your purchase.
          </Typography>
        </Box>
      </Container>
    </>
  );
}
